var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSet8Link7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C5C5C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4402 9.15763C17.6068 7.79101 19.6796 7.60948 21.075 8.74607L22.8105 10.1597C24.2123 11.3016 24.4039 13.3445 23.2318 14.7177L20.3371 18.1087C19.1706 19.4754 17.0977 19.6569 15.7024 18.5203L14.4006 17.46L14.995 16.7303L16.2968 17.7906C17.2984 18.6065 18.7891 18.4726 19.6213 17.4977L22.5159 14.1066C23.3426 13.1382 23.2113 11.7001 22.2161 10.8894L20.4806 9.4758C19.4789 8.65987 17.9883 8.79373 17.156 9.76868L16.1876 10.9033L15.4717 10.2922L16.4402 9.15763ZM11.6629 13.8913C12.8294 12.5246 14.9023 12.3431 16.2976 13.4797L17.8664 14.7575L17.272 15.4873L15.7032 14.2094C14.7016 13.3935 13.2109 13.5274 12.3787 14.5023L9.48407 17.8934C8.65743 18.8618 8.7887 20.2999 9.78392 21.1106L11.5194 22.5242C12.5211 23.3401 14.0117 23.2063 14.844 22.2313L15.6399 21.2989L16.3557 21.9099L15.5598 22.8424C14.3932 24.209 12.3204 24.3905 10.925 23.2539L9.18953 21.8403C7.78771 20.6984 7.59611 18.6555 8.76823 17.2823L11.6629 13.8913Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSet8Link7);
export default __webpack_public_path__ + "static/media/set_8_Link-7.25d1c0b9.svg";
export { ForwardRef as ReactComponent };